import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CMSPath, globalIV, globalSalt } from '../../../config/constant'
import { setSelectedList } from '../../action/homeAction'
import { saveGuestRequest } from '../../../action/guestRequest'
import { closeOrderPopUp } from '../../action/hCommerce2'
import { popUpConfig } from '../../JS/colorConfig'
import Loader from '../../UI/loader';
import $ from 'jquery';
import { contScrollToBottom, contScrollToTop, hideScrolltoTopHandler } from '../../JS/scroll';
import {withTranslation} from "react-i18next";
import GuestSelectDropdown from '../../UI/SelectDropdown'
import { AesUtil } from '../../../JS/AesUtil'

class OrderRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showRequestDetail: false,
            showGuestDetail: false,
            selectedName: null,
            AdditionalNote: null,
            showNameList: false,
            showScrollToTop:false,
            
        }
        this.aesUtil = new AesUtil(128, 1000);
    }

    componentWillUnmount() {
        $("body").removeClass("overlay-cast");
    }

    componentDidUpdate(preProp,prevState) {
        popUpConfig(this.props.menuColor);
        if (preProp.CheckedInGuest !== this.props.CheckedInGuest) {
            if (this.props.CheckedInGuest.length === 1) {
                this.setState({ selectedName: this.props.CheckedInGuest[0].guestName })
            }
        }

        if(preProp.selectedList.length !== this.props.selectedList.length){
            $('#my-orders').addClass("shake")
            setTimeout(() => {
                $('#my-orders').removeClass("shake")
            }, 500);
        }

        if(this.props.showGuestRequestDataState && this.state.showRequestDetail){
            this.closeDetailsPage();
        }
    }

    componentDidMount(){
        popUpConfig(this.props.menuColor);
        if(this.props.CheckedInGuest && this.props.CheckedInGuest.length === 1){
            this.setState({selectedName:this.props.CheckedInGuest[0].guestName})
        }
    }


    openDetailPage = () => {
        this.props.handleshowGuestRequestData(false);
        this.setState({ showRequestDetail: !this.state.showRequestDetail });
    }

    closeDetailsPage = () => {

        if (this.state.showGuestDetail) {
            this.setState({ showGuestDetail: false });
            this.setState({ showRequestDetail: true });
            return;
        }

        this.props.handleshowGuestRequestData(true);
        this.setState({ showGuestDetail: false });
        this.setState({ showRequestDetail: false });
    }
    removeFromList = (id) => {
        let selectedList = [...this.props.selectedList]
        if (selectedList.indexOf(id) !== -1) {
            selectedList.splice(selectedList.indexOf(id), 1);
            this.props.setSelectedList(selectedList);
        }
    }
    formOnSubmit = (event) => {
        event.preventDefault();
    }
    proceedToOrder = () => {
        this.setState({ showRequestDetail: false, showGuestDetail: true })
    }
    showNameList = () => {
        this.setState({ showNameList: !this.state.showNameList })
    }
    setSelectedName = (name) => {
        this.setState({ selectedName: name, showNameList: false })
    }

    setNote = (event) => {
        this.setState({ AdditionalNote: event.target.value });
    }

    submitTheRequest = () => {
        let sessionToken = localStorage.getItem('GuestJourneySessionToken');
        let selectedGuest = null
        if (this.state.selectedName) {
            this.props.CheckedInGuest.map((iterator, index) => {
                if (iterator.guestName == this.state.selectedName) {
                    console.log("guestName", iterator.guestName);
                    selectedGuest = iterator
                }
            })
        } else if(localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) {
            selectedGuest = JSON.parse(this.aesUtil.decrypt(globalSalt, globalIV, "1234567891234567", (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))));
        } else {
            console.log("please select guest name.");
            this.props.closeOrderPopUp(true, "", this.props.t('guest_request.select_guest_name'),true);
        }

        if (this.props.selectedList.length === 0) {
            console.log("please select item to request.");
            this.props.closeOrderPopUp(true, "", this.props.t('guest_request.select_request'),true);
        }
        //API call for Guest request
        if (selectedGuest && sessionToken && this.props.selectedList.length > 0) {
            this.props.setSendRequestInProg(true);
            this.props.saveGuestRequest(
                selectedGuest, 
                sessionToken, 
                this.props.selectedList, 
                this.state.AdditionalNote,
                this.saveRequestCallback
                );
            // this.props.closeOrderPopUp(true, "Successfully", "");
            this.props.setSelectedList([]);

        }
    }

    saveRequestCallback = (status,msg) => {

        if(status){
            this.props.closeOrderPopUp(true, "", msg || this.props.t('guest_request.request_sent_msg'), false);
        } else {
            this.props.closeOrderPopUp(true, "", msg || this.props.t('guest_request.something_went_wrong'), true);
        }
        this.props.setSendRequestInProg(false);
    }

    GuestReqItem = (iterator, index)=>{
        const imagePath = encodeURI(`${CMSPath}${this.props.imageBaseUrl}${iterator.imageName}`)
        return (
            <div key={index} class="row order-row">
                  <div class="close" style={{ backgroundColor: this.props.menuColor.assetBackgroundSelectorColor }}
                      onClick={() => this.removeFromList(iterator.serviceRequestId)}><i class="fa fa-times"></i></div>
                            <div class="col col-4 order-preview" style={{ backgroundImage: `url('${imagePath}')`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat", height: "100%", width: "30%", backgroundSize: "cover" }}></div>
                                <div class="col col-4 order-details">
                                     <div class="order-name">
                                         <p class="item-name" dangerouslySetInnerHTML={{ __html: `${iterator.name}` }}></p>
                                             <p class="item-description" dangerouslySetInnerHTML={{__html: `${iterator.description}`}}></p>
                                           </div>
                                        </div>
                                   </div>
        )
}


    render() {
        let imagePath
        const { t } = this.props

        return (
            <>
                {(!this.state.showGuestDetail && !this.state.showRequestDetail) ?
                    <section id='my-orders' class={`my-orders ${this.state.showRequestDetail || this.state.showGuestDetail ? "overlay" : ""}`}>
                        <div class="orders-container">
                            <div onClick={this.openDetailPage} class="orders-heading">
                                <h5>{t('guest_request.header')} <span class="cart-item" >{this.props.selectedList.length}</span></h5>
                                <a onClick={this.openDetailPage} class="order-toggle" >
                                    <i className={
                                        this.state.showRequestDetail || this.state.showGuestDetail ?
                                            "fas fa-lg fa-chevron-down" : "fas fa-lg fa-chevron-up"
                                    }
                                    ></i></a>
                            </div>
                        </div>
                    </section>

                    : (this.state.showRequestDetail) &&
                    <>
                        <section class="widgets">
                            <div class="widget-header">
                                <div class="widget-header-title" style={{ textTransform: "uppercase", padding: "1rem", textAlign: "center" }}>{t('guest_request.header')}</div>
                            </div>

                            <div class="orders-body-container app-body">

                                {(this.props.selectedList.length > 4) && <div class="orders-body-scroller">
                                    {this.state.showScrollToTop && <div onClick={() => contScrollToTop("my-request-order-body")} class="orders-scroll scroll-up"><i class="fa fas fa-chevron-up"></i></div>}
                                    <div onClick={() => contScrollToBottom("my-request-order-body")} class="orders-scroll scroll-down"><i class="fa fas fa-chevron-down"></i></div>
                                </div>}

                                <div class="orders-body">


                                {this.props.groupedGuestRequestData 
                                          ?
                                          this.props.groupedGuestRequestData && this.props.groupedGuestRequestData.length > 0 &&
                                          this.props.groupedGuestRequestData.map((group, index) => (
                                              group.requestMaster.length > 0 &&
                                              group.requestMaster.map((iterator, idx) => (
                                                  this.props.selectedList.indexOf(iterator.serviceRequestId) !== -1 && (
                                                      this.GuestReqItem(iterator,idx)
                                                  )
                                              ))
                                          ))
                                          :
                                          this.props.guestRequestList.length > 0 &&
                                            this.props.guestRequestList.map((iterator, idx) => {
                                                if (this.props.selectedList.indexOf(iterator.serviceRequestId) !== -1) {
                                                    imagePath = encodeURI(`${CMSPath}${this.props.imageBaseUrl}${iterator.imageName}`)
    
                                                    return (
                                                    this.GuestReqItem(iterator,idx)
                                                    )
                                                }
                                            })
                                }
                            
                                </div>

                                <div class="widget-header">
                                    <div class="widget-header-title" style={{ textTransform: "uppercase", padding: "1rem", textAlign: "center" }}>{t('guest_request.place_request')}</div>
                                </div>

                                <div class="order-payment">

                                    {this.props.CheckedInGuest.length > 1 &&
                                        <div class="form-row" style={{ zIndex: "5" }}>
                                            <label id="guest-name" for="cust-name" class="align-left">{t('guest_request.name')}<span style={{ color: "red" }}>*</span></label>
                                            <GuestSelectDropdown
                                                selectedItem={this.state.selectedName}
                                                listData={this.props.CheckedInGuest}
                                                showList={this.state.showNameList}
                                                setShowList={() => this.setState(prev => ({ showNameList: !prev.showNameList }))}
                                                setSelectedItem={(obj) => {
                                                    this.setSelectedName(obj.guestName)
                                                }}
                                                selectKey="obj.guestName"
                                            />
                                        </div>
                                    }

                                    <div class="form-row">
                                        <label for="req-details">{t('guest_request.details')}</label>
                                        <textarea name="req-details" id="req-details" value={this.state.AdditionalNote} onChange={this.setNote} rows="5" placeholder={t('guest_request.add_detail')}></textarea>
                                    </div>

                                </div>

                            </div>
                        </section>

                        <footer class="button-controls">
                            <section class="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                <button onClick={this.submitTheRequest} class="primary w-100 all-caps">{t('guest_request.send_request_btn')}</button>
                                <button onClick={this.closeDetailsPage} class="secondary w-100 all-caps margin-top-1">{t('guest_request.back')}</button>
                            </section>
                        </footer>

                    </>
                }
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        currentWidget: state.store.sideNavBar.currentWidget,
        guestRequestList: state.store.guestRequest.guestRequestList,
        imageBaseUrl: state.store.guestRequest.guestRequestOtherData ?
            state.store.guestRequest.guestRequestOtherData.imageBaseUrl : null,
        menuColor: state.store.home.MenuColor,
        displayName: state.store.sideNavBar.currentWidget.displayName,
        CheckedInGuest: state.store.CheckedInGuest,
        selectedList: state.store2.selectedList,
        groupedGuestRequestData: state.store.guestRequest.groupedGuestRequestData,
    }
}
export default connect(
    mapStateToProps,
    {
        // setRegPage,
        // getGuestInRoom,
        // getGuestRequestList,
        // getItemType,
        // changePage,
        setSelectedList,
        saveGuestRequest,
        closeOrderPopUp
    }
)(withTranslation('translations')(OrderRequest));